"use client";
import { useRouter, useParams } from "next/navigation";
import { useEffect } from "react";

import { BlogServices } from "@/services";
import toast from "react-hot-toast";
function useSingleBlog() {
  const { data: categories } = BlogServices().useGetAllBlogCategory();
  const router = useRouter();
  const params = useParams();

  const slug = params.slug as string;

  const { data: singleBlog, isLoading: blogLoading } =
    BlogServices().useGetSingleBlog(slug as string);

  const { mutate: incrementView } = BlogServices().useIncrementBlogView();

  const handleShare = async () => {
    const shareData = {
      title: singleBlog?.title,
      text: singleBlog?.description,
      url: window.location.href,
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        await navigator.clipboard.writeText(window.location.href);
        toast.success("Link copied successfully");
      }
    } catch (error) {
      console.log(error);
    }
  };

  // INCREMENT VIEW
  useEffect(() => {
    if (slug) {
      incrementView(slug);
    }
  }, [slug, incrementView]);

  return { singleBlog, router, blogLoading, categories, handleShare };
}

export default useSingleBlog;
